module.exports = __webpack_public_path__ + "img/check-box-checked.d5f263f5.svg";